// extracted by mini-css-extract-plugin
module.exports = {"grid":"Body_grid__2jWCr","item":"Body_item__1m6Vm","label":"Body_label__1QDUm","value":"Body_value__e35hd","xl":"Body_xl__cMe27"};